import { Component, OnInit, Input, Output, ChangeDetectorRef, EventEmitter } from '@angular/core';
// import { FormBuilder, FormGroup } from '@angular/forms';
// import { Router, ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { KeyValueModel } from './../../model/key-value-modal';
import { LifeStyleQuestion } from 'src/app/pages/medical-underwriting/model';
import { UntypedFormGroup } from '@angular/forms';
// import { Store } from '@ngrx/store';
// import { AppState } from '../..../../../store/state/app.state';
import { SERVICE_END_POINT, UtilService } from 'src/app/shared';
@Component({
  selector: 'app-radio-button-dot',
  templateUrl: './radio-button-dot.component.html',
  styleUrls: ['./radio-button-dot.component.scss']
})
export class RadioButtonDotComponent implements OnInit {

  public radioSelected: string;
  public radioListSelected: string[];
  private CMSData;
  @Input() labelRadBtn: string;
  @Input() optionsListRadBtn: KeyValueModel[];
  @Input() config: LifeStyleQuestion;
  @Input() parent: UntypedFormGroup;
  @Input() parentControlName: string;
  @Input() radioList: string[];
  @Input() defaultSelectedValue: string = "";
  @Output() selectedValueEmitterRadBtn: EventEmitter<string> = new EventEmitter<string>();
  existingLabel: string;
  constructor(private utilService: UtilService) { }
  ngOnInit(): void {
    this.GetCMSDataServiceMapper();
    //console.log('RadioList Init=>', this.radioList);
    this.setRadioList();
    if (this.defaultSelectedValue) {
      this.onChangeRadioOption(this.defaultSelectedValue);
    }
  }
  setRadioList = () => {
    this.radioListSelected = [];
    this.radioList.forEach(radio => {
      this.radioListSelected.push(radio['response']);
    });
  }
  onChangeRadioOption(selectedValue: string) {
    this.radioSelected = selectedValue;
    //console.log('RadioList Init=>', this.radioSelected);

    this.selectedValueEmitterRadBtn.emit(selectedValue);
  }
  /** Code block for CMS */
  GetCMSDataServiceMapper() {

    const URL = SERVICE_END_POINT.higherEnvironment.CMS_AddMedicalCondition;
    //console.log('changed value = ');
    this.utilService.getCMSData(URL).subscribe(res => {
      //console.log('2 GetCMSDataService => ', res);
      this.CMSData = res;
      if (this.CMSData) {
        /** In the line below we are over-writing the contentData object values with CMSData object values */
        this.radioList[0] = this.CMSData.commonBlock.string_HighBloodPressureTitle;
        this.radioList[1] = this.CMSData.commonBlock.string_HighCholesterolTitle;
        this.radioList[2] = this.CMSData.commonBlock.string_DiabetesTitle;
        this.radioList[3] = this.CMSData.commonBlock.string_LungRespiratoryDiseaseTitle;
        this.radioList[4] = this.CMSData.commonBlock.string_HeartDiseaseTitle;
        this.radioList[5] = this.CMSData.commonBlock.string_CancerTitle;
        this.radioList[6] = this.CMSData.commonBlock.string_StrokeTitle;
        this.radioList[7] = this.CMSData.commonBlock.string_NeurologicalDiseaseTitle;
        this.radioList[8] = this.CMSData.commonBlock.string_MultipleSclerosisTitle;
        this.radioList[9] = this.CMSData.commonBlock.string_OtherMedicalConditionsTitle;
        this.existingLabel = this.CMSData.string_AllReadyDisclosed;
      }
    });
  }
  /** End of code block for CMS */
}
